import {Component, Input} from "@angular/core";
import {ScreeningAlert, ScreeningHit} from "../../../../../../model/lookup-results.model";

@Component({
  selector: "single-common-result-flag-screening",
  templateUrl: "./screening.component.html",
  styleUrls: ["./screening.component.css"]
})
export class SingleCommonResultFlagScreeningComponent {

  @Input() alert: ScreeningAlert

  getNumberValue(value: number | undefined) {
    return value ?? 0.0;
  }

  // riskClass(risk: string) {
  //   if (risk == "high") {
  //     return "danger";
  //   } else if (risk == "medium") {
  //     return "warning";
  //   } else if (risk == "low") {
  //     return "success";
  //   }
  //   return "danger";
  // }

  riskClass(alert: ScreeningAlert) {
    if (alert.risk == "high") {
      return "danger";
    } else if (alert.risk == "medium") {
      return "warning";
    } else if (alert.risk == "low") {
      return "success";
    }
    return "danger";
  }

}
